import { forwardRef } from 'react';

/**
 * Shared text input — md (dashboard) / lg (auth).
 */
export const Input = forwardRef(function Input(
  {
    size = 'md',
    error = false,
    className = '',
    autoComplete = 'off',
    ...props
  },
  ref,
) {
  const sizeClasses =
    size === 'lg'
      ? 'h-[52px] px-4 sm:px-5 rounded-input text-h6-normal'
      : 'h-[40px] sm:h-[44px] px-3 sm:px-4 rounded-xl text-xs sm:text-sm';

  return (
    <input
      ref={ref}
      autoComplete={autoComplete}
      className={`w-full bg-input-background border font-sf-pro-display text-text-primary placeholder-text-muted focus:outline-none transition-all cursor-text disabled:bg-gray-200/80 disabled:text-gray-400 disabled:border-gray-300 disabled:cursor-not-allowed disabled:opacity-85 ${sizeClasses} ${
        error
          ? 'border-status-error focus:border-status-error focus:ring-[3px] focus:ring-status-error/15'
          : 'border-border-default focus:border-primary focus:ring-[3px] focus:ring-primary/15'
      } ${className}`}
      {...props}
    />
  );
});
